import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { WikiHome } from './pages/WikiHome';
import { SpeciesListPage } from './pages/SpeciesListPage';
import { SpeciesDetailPage } from './pages/SpeciesDetailPage';

export const WikiRouter: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<WikiHome />} />
      <Route path="/peixes" element={<SpeciesListPage />} />
      <Route path="/peixes/:slug" element={<SpeciesDetailPage />} />
    </Routes>
  );
};
